// extracted by mini-css-extract-plugin
export default {"row":"PalletsPricingPerAddressesTableInnerRow_row__hBhs8","cell":"PalletsPricingPerAddressesTableInnerRow_cell__8cX2Y"};